module.exports = __webpack_public_path__ + "static/media/link.d956a691.svg";